<h2 class="banner-title">{{data.title | translate}}</h2>
<div class="row-when-if-need-margin justify-content-center">
  <div class="col">
    <a class="btn btn-primary mdlb-banner-button" title="{{data.title | translate}}" (click)="navigate()" href="javascript:void(0)">{{data.linkText
        | translate}}</a>
  </div>
</div>
